import React, {useState, useEffect} from "react";
import {useHistory, useParams} from "react-router-dom";
import {MUISortOptions} from "mui-datatables";
import moment from "moment";

import GenericTemplate from "../../templates/GenericTemplate";
import {
  apollo_useStyles,
} from "../../atom/Apollo_styles";
import {
  APOLLO_GROUP_OPERATOR,
  ApolloPageUsagePermission,
  APOLLO_PROFILE_SYSTEM_OPERATOR
} from "../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";
import {
  apollo_budgets_path,
  apollo_budgetno_master_path,
  budget_path,
} from "../../atom/Apollo_links";
import {
  AccountBudget,
  AccountBudgetDisplay,
  MenuAmountInfo,
} from "./BudgetModel";
import {ApolloDataTable, STORAGE_KEY} from "../../atom/Apollo_DataTable";
import {CustomizedSnackbars} from "../../atom/Apollo_Mesasge"
import {BudgetnoMaster} from "../../organism/MASTER/Apollo_MasterModel";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import {ApolloContext} from "../../atom/Apollo_Context";
import {ApolloRightDrawerContext, RightDrawer} from "../../molecule/Apollo_RightDrawer";
import ApolloBudgetEdit from "../../organism/BUDGET/Apollo_BudgetEdit";
import {BudgetColumns, CsvData} from "../../common/Apollo_CommonConst";
import {optionsZeusDeliveryShortType} from "../../common/Apollo_CommonConst";
// メッセージ定義
import {
  GetMessage,
  UI_BUDGET_LIST,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

import Card from "@material-ui/core/Card/Card";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import Box from "@material-ui/core/Box"
import Tooltip from '@material-ui/core/Tooltip/Tooltip'
import {Chip} from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { find } from "lodash";

/*
    画面名：予算管理一覧画面
 */
const BudgetPage: React.FC = () => {
  // コンテキストのアカウント情報
  const {state,dispatch} = React.useContext(ApolloContext);

  const {yearMonth} = useParams<{ yearMonth: string }>();
  const history = useHistory();
  const classes = apollo_useStyles();
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [rows, setRows] = useState<AccountBudget[]>([]);
  const [budgetnoMaster, setBudgetnoMaster] = useState<BudgetnoMaster[]>([]);
  const [disabledButton1, setDisabledButton1] = useState(true);
  const [disabledButton2, setDisabledButton2] = useState(false);
  // 初期値は当月
  const budgetMonth1 = moment().format("YYYYMM");
  const budgetMonth2 = moment().add(1, 'months').format("YYYYMM");
  const [budgetMonth, setBudgetMonth] = useState(yearMonth ? (yearMonth === budgetMonth1 ? budgetMonth1 : budgetMonth2) : budgetMonth1);
  // リンク表示用年月
  const dispMonth = moment().format("YYYY年M月");
  const dispNextMonth = moment().add(1, 'months').format("YYYY年M月");
  // 予算設定に引き継ぐアカウントID
  const [accountId, setAccountId] = useState(0);
  // 予算設定に引き継ぐアカウントグループID
  const [accountgroupId, setAccountgroupId] = useState(0);
  // 再読み込みフラグ
  const [read, setRead] = useState(false);
  // 表示データ
  const [displayData, setDisplayData] = useState<AccountBudgetDisplay[]>();
  // effect用年月
  const [parentYearMonth, setParentYearMonth] = useState(budgetMonth);
  // メニュー予算JSONキー名
  const MENU_AMOUNT_COLUMN_NAME = "menuAmount_";

  const [sortOrder, setSortOrder] = useState<MUISortOptions>({
    name: "accountgroupId",
    direction: 'asc',
  })
  const [optionsDisplay, setOptionsDisplay] = useState<boolean[]>([false, false])
  const [numberOfRows, setNumberOfRows] = useState(10)
  const DELIVERY_MESSAGE_0 = "キャンペーン種別予算が設定されていません。"

  // 編集画面からのEffect
  useEffect(() => {
    if (parentYearMonth === budgetMonth1) {
      handleChange1();
    } else {
      handleChange2();
    }
  }, [parentYearMonth]);

  useEffect(() => {
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true,
      }
    });
    // 予算枠番号マスター取得
    const path = apollo_budgetno_master_path;
    ApolloAxios.get(path).then(response => {
      if (response.data.resultCode === 0) {
        const newBudgetNoMaster = mergeBudgetnoMaster(response.data.result);
        setBudgetnoMaster(newBudgetNoMaster.filter((m) => m.budgetNo !== 22));
      } else {
        console.log(response.data.message)
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_BUDGET_LIST,"E","1"),
            loading: false,
          }
        });
      }
    }).catch(err => {
			// 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_BUDGET_LIST,"E","1"), data, setmsg, history)) {
				// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
			}
    });
  }, []);

  useEffect(() => {
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true,
      }
    });
    // 広告主アカウント月額予算取得
    const url = apollo_budgets_path + "/" + budgetMonth1 + "/" + state.current.accountGroupId;
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === 0) {
        setRows(response.data.result);
      } else {
        console.log(response.data.message);
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_BUDGET_LIST,"E","0"),
            loading: false
          }
        });
      }
    }).catch(err => {
			// 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_BUDGET_LIST,"E","0"), data, setmsg, history)) {
				// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
			}
		}).finally(() => {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false,
        }
      });
    });
  }, [read]);

  // 表示データ変更Effect
  useEffect(() => {
    createDisplayData();
  }, [rows, budgetnoMaster]);

  // 表示データを作成する
  const createDisplayData = () => {
    if ((!(rows && budgetnoMaster)) || (rows.length < 1 || budgetnoMaster.length < 1)) return;
    var diaplayListData1: AccountBudgetDisplay[] = [];
    rows.map((row) => {
      var amountList: MenuAmountInfo[] = [];
      var workMenuAmountDisplay: number[] = [];
      var workMessage = "";
      budgetnoMaster.map((budgetno) => {
        var amountInfo: MenuAmountInfo = {
          budgetNo: budgetno.budgetNo,
          menuId: 0,
          platformAccountId: "",
          amount: 0,
          amount1: 0,
          amount2: 0,
          message: "",
        };
        if (row.amounts) {
          row.amounts.map((amount) => {
            if (amount.budgetNo === budgetno.budgetNo) {
              amountInfo.menuId = amount.menuId;
              amountInfo.platformAccountId = amount.platformAccountId;
              if (budgetMonth !== budgetMonth1) {
                amountInfo.amount = amount.nextBudgetAmount;
              } else {
                amountInfo.amount = amount.budgetAmount;
              }
              amountInfo.amount1 = amount.budgetAmount;
              amountInfo.amount2 = amount.nextBudgetAmount;
              amountInfo.message = amount.message;
              if (amount.message !== "") {
                workMessage = "メニュー予算変更エラー";
              }
            }
            return null;
          });
        }
        workMenuAmountDisplay.push(amountInfo.amount);
        amountList.push(amountInfo);
        return null;
      });
      var diaplayData: AccountBudgetDisplay = {
        accountId: row.accountId,
        accountName: row.accountName,
        accountgroupId: row.accountgroupId,
        accountgroupName: row.accountgroupName,
        budgetAmount: budgetMonth === budgetMonth1 ? row.budgetAmount : row.nextBudgetAmount,
        budgetAmount1: row.budgetAmount,
        budgetAmount2: row.nextBudgetAmount,
        menuAmount: amountList,
        menuAmountDisplay: workMenuAmountDisplay,
        message: workMessage,
      };
      // メニュー予算をJSON形式に変換し、表示用のJSONに結合する
      var amountJson = convAmountJson(workMenuAmountDisplay);
      Object.assign(diaplayData, amountJson);
      diaplayListData1.push(diaplayData);
      return null;
    });
    setDisplayData(diaplayListData1);
    // 年月ボタンセット
    setButtonMonth();
  };

  // 数値配列をJSON形式に変換
  const convAmountJson = (numberArray: number[]) => {
    var workJson = {};
    numberArray.map((num, index) => {
      var colummName = MENU_AMOUNT_COLUMN_NAME + index;
      Object.assign(workJson, {[colummName]: num})
      return null;
    });
    return workJson;
  }

  // 予算枠番号マスター情報にZeus配信種別のレコードを追加
  const mergeBudgetnoMaster = (budgetnoMaster: BudgetnoMaster[]) => {
    const BUDGET_NO_PLAS = 30;
    const sortBudgetnoMasterList = budgetnoMaster.map((v) => {
      var sortBudgetnoMaster: BudgetnoMaster = {
        budgetNo : v.budgetNo,
        budgetName : v.budgetName,
        budgetAmountFlg : v.budgetAmountFlg,
        colorCode : v.colorCode,
        sort : v.budgetNo >= 20 ? v.budgetNo : v.budgetNo + BUDGET_NO_PLAS,
      }
      return sortBudgetnoMaster;
    })

    // Zeus配信種別別月額予算props引数
    const newBudgetnoMasterList = optionsZeusDeliveryShortType.map((v) => {
      var newBudgetnoMaster: BudgetnoMaster = {
        budgetNo : 1 * 10 + v.value,
        budgetName : budgetnoMaster[0].budgetName + "_" + v.label,
        budgetAmountFlg : 2,
        colorCode : "#FFFFFF",
        sort : 1 * 10 + v.value + BUDGET_NO_PLAS,
      }
      return newBudgetnoMaster;
    })
    const result = sortBudgetnoMasterList.concat(newBudgetnoMasterList);
    result.sort((a, b) => a.sort - b.sort);
    return result;
  }
  // リストカラム定義
  const columns1 = [
    {
      name: "accountId",
      label: "広告主アカウントID",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "accountName",
      label: "広告主アカウント名",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "accountgroupId",
      label: "アカウントグループID",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "accountgroupName",
      label: "アカウントグループ名",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "budgetAmount",
      label: "アカウント月額予算",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (num: number) => {
          return "￥" + Number(num ? num : 0).toLocaleString();
        },
      },
    },
  ];

  // メニューリスト
  const columns2 = budgetnoMaster.filter(data => data.budgetNo !== 11 && data.budgetNo !== 12).map((data, index) => {
    return {
      name: MENU_AMOUNT_COLUMN_NAME + index,
      label: data.budgetName,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (num: number, tableMeta: any) => {
          var result = "￥" + Number(num ? num : 0).toLocaleString();
          // パフォーマンス広告予算が1円以上でかつ配信種別毎の予算が全て0円の場合、アラートアイコンを表示する
          if (data.budgetNo === 10 && tableMeta.rowData[6] > 0 && tableMeta.rowData[7] === 0 && tableMeta.rowData[8] === 0) {
            return <>{result} <img src={"/icon/icon_alert_48.png"} alt="alert" title={DELIVERY_MESSAGE_0} height="20" width="20" /></>;
          }
          return result;
        },
      },
    }
  });

  // Zeusキャンペーンリスト
  const columns3 = budgetnoMaster.filter(data => data.budgetNo == 11 || data.budgetNo == 12).map((data, index) => {
    return {
      name: MENU_AMOUNT_COLUMN_NAME + (columns2.length + index),
      label: data.budgetName,
      options: {
        display: data.budgetNo === 11 ? optionsDisplay[0] : optionsDisplay[1],
        filter: false,
        sort: true,
        customBodyRender: (num: number) => {
          return "￥" + Number(num ? num : 0).toLocaleString();
        },
      }, 
    }
  });

  // リストカラム定義
  const columns4 = [
    {
      name: "message",
      label: " ",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: (idx: number) => {
          var messages = [];
          var messageBefore = "";
          for (var idx2 in rows[idx].amounts) {
            if (rows[idx].amounts[idx2].message !== undefined) {
              if (rows[idx].amounts[idx2].message !== "" && rows[idx].amounts[idx2].message !== messageBefore) {
                messages.push(rows[idx].amounts[idx2].message);
                messageBefore = rows[idx].amounts[idx2].message;
              }
            }
          }
          var message = messages.join(",");
          var label = "";
          if (message !== "") {
            label = "エラー";
          }
          return (
            <Tooltip title={message} placement="bottom-end">
              <Chip
                label={
                  <Typography variant="subtitle2">{label}</Typography>
                }
                style={
                  { backgroundColor: "red", color: 'white', height: "50%" }
                }
              />
          </Tooltip>
          )
        }
      }
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (idx: number) => {
          return (
            <Button
              className={classes.buttonTop}
              variant={"contained"}
              color={"primary"}
              onClick={() => {
                setDrawerState({
                  type: 'open',
                  payload: {
                    ...drawerState,
                    open: true,
                  }
                })
                handleClickEditOpen(rows[idx].accountId, rows[idx].accountgroupId)
              }}
            >
              編集
            </Button>
          );
        }
      },
    },
    {
      name: "",
      label: "詳細",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (idx: number) => {
          return (
            <KeyboardArrowRightIcon
              onClick={() => handleClickDetailOpen(rows[idx].accountId, rows[idx].accountName, rows[idx].accountgroupId)}
              className={classes.link}
              style={{cursor: "pointer"}}
            />
          );
        }
      },
    },
  ];

  columns2.map((column) => {
    // @ts-ignore
    columns1.push(column);
    return null;
  });

  columns3.map((column) => {
    // @ts-ignore
    columns1.push(column);
    return null;
  });

  columns4.map((column) => {
    columns1.push(column);
    return null;
  });

  // 編集ボタンハンドラ
  const handleClickEditOpen = (accountId: number, accountgroupId: number) => {
    setAccountId(accountId);
    setAccountgroupId(accountgroupId);
  }

  // 詳細リンクハンドラ
  const handleClickDetailOpen = (accountId: number, accountName:string, accountgroupId: number ) => {
    // 画面遷移
    //コンテキストを更新
    var roleAuthorization = 0
    var customSegment = 1
    var geoSegment = 1
    var accountgroupName = ""
    state.apolloList.find((v) => {
      if (v.accountGroup.id === accountgroupId) {
        roleAuthorization = v.accountGroup.roleAuthorization;
        customSegment = v.accountGroup.customSegment;
        geoSegment = v.accountGroup.geoSegment;
        accountgroupName = v.accountGroup.name
      }
    })
    dispatch({
      type: "changeAccount",
      payload: {
        ...state,
        current: {
          ...state.current,
          accountGroupId: accountgroupId,
          accountGroupName: accountgroupName,
          accountId: accountId,
          accountName: accountName,
          roleAuthorization: roleAuthorization,
          customSegment: customSegment,
          geoSegment: geoSegment,
        }
      }
    });

    history.push(budget_path + "/" + accountId + "/" + budgetMonth);
  }

  // 年月ボタンセット
  const setButtonMonth = () => {
    if (budgetMonth === budgetMonth1) {
      handleChange1();
    } else {
      handleChange2();
    }
  };

  // 当月変更ハンドラ
  const handleChange1 = () => {
    setDisabledButton1(true);
    setDisabledButton2(false);
    setBudgetMonth(budgetMonth1);
    // 当月予算を表示用にセット
    displayData?.map((data) => {
      data.budgetAmount = data.budgetAmount1
      budgetnoMaster.map((_, index) => {
        // メニュー予算のJSONキー名を決めて、表示用のJSON値に代入する
        var columnName = MENU_AMOUNT_COLUMN_NAME + index;
        // @ts-ignore
        data[columnName] = data.menuAmount[index].amount1;
        return null;
      });
      return null;
    });
  };

  // 翌月変更ハンドラ
  const handleChange2 = () => {
    setDisabledButton1(false);
    setDisabledButton2(true);
    setBudgetMonth(budgetMonth2);
    // 翌月予算を表示用にセット
    displayData?.map((data) => {
      data.budgetAmount = data.budgetAmount2
      budgetnoMaster.map((_, index) => {
        // メニュー予算のJSONキー名を決めて、表示用のJSON値に代入する
        var columnName = MENU_AMOUNT_COLUMN_NAME + index;
        // @ts-ignore
        data[columnName] = data.menuAmount[index].amount2;
        return null;
      });
      return null;
    });
  };

  // データリスト表示オプション
  const options = {
    filter: true,
    downloadOptions: {
      filename: `budgets_${disabledButton1 ? budgetMonth1 : budgetMonth2}.csv`,
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      }
    },
    onDownload: (buildHead: any, buildBody: any, columns: any, data: any) => {
      const csvData = formatCsvData(data, displayData ?? [], disabledButton1);
      return "\uFEFF" + buildHead(BudgetColumns) + buildBody(csvData);
    },
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.BUDGET) ? undefined : sortOrder,
    selectableRows: 'none',
    rowsPerPage: numberOfRows,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    storageKey: STORAGE_KEY.BUDGET,
    onColumnSortChange: (changedColumn: string, direction: string) => {
      setSortOrder({
        name: changedColumn,
        direction: direction,
      } as MUISortOptions)
    },
    onChangeRowsPerPage: (numberOfRows: number) => setNumberOfRows(numberOfRows),
    customSearch: (searchQuery: string, currentRow: any[], columns: any[]) => {
      let isFound = false;
      currentRow.forEach((col, index) => {
        // 配信種別カラムは検索対象外とする（currentRowにはundefinedもあるため条件に追加）
        if (col !== undefined && index !== 9 && index !== 10) {
          if (col.toString().indexOf(searchQuery) >= 0) {
            isFound = true;
          }
        } 
      });
      return isFound;
    },
    onViewColumnsChange: (column: any, action: any) => {
      // 配信種別のカラム表示を保存する（年月選択時に表示中が非表示にならないため）
      if (column === MENU_AMOUNT_COLUMN_NAME + 2) {
        if (action === "add") {
          setOptionsDisplay([true, optionsDisplay[1]])
        } else {
          setOptionsDisplay([false, optionsDisplay[1]])
        }
      } else if (column === MENU_AMOUNT_COLUMN_NAME + 3) {
        if (action === "add") {
          setOptionsDisplay([optionsDisplay[0], true])
        } else {
          setOptionsDisplay([optionsDisplay[0], false])
        }
      }
    },
  }

  // 画面表示
  return (
    <GenericTemplate title="">
      <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_PROFILE_SYSTEM_OPERATOR}>
        <ApolloBreadcrumbs bread_no={71} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""}
                           platform={""}/>
        <RightDrawer>
          <ApolloBudgetEdit accountgroupId={accountgroupId} accountId={accountId} yearMonth={budgetMonth} read={read}
                            setRead={setRead} setParentYearMonth={setParentYearMonth}/>
        </RightDrawer>

        <Grid item xs={12} spacing={0} container>
          <Grid item xs={12} md={8}>
            <Typography variant="caption" display="block">
              <ul>
                <li style={{listStyle: 'square'}}>
                  現在、各アカウントに設定されている予算状況となります。<br/>翌月以降の予算を変更する場合、翌月ボタンにて更新をお願いします。
                </li>
              </ul>
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="button" display="block" align="right">
              {disabledButton1 ?
                <>
                  <Button size="small"><span
                    style={{borderBottom: "solid", borderColor: "red", borderWidth: "3px"}}>{dispMonth}</span></Button>
                  <Box display="inline">|</Box>
                  <Button color="primary" size="small" onClick={() => handleChange2()}><span style={{
                    borderBottom: "solid",
                    borderColor: "white",
                    borderWidth: "3px"
                  }}>{dispNextMonth}</span></Button>
                </>
                :
                <>
                  <Button color="primary" size="small" onClick={() => handleChange1()}><span style={{
                    borderBottom: "solid",
                    borderColor: "white",
                    borderWidth: "3px"
                  }}>{dispMonth}</span></Button>
                  <Box display="inline">|</Box>
                  <Button size="small"><span style={{
                    borderBottom: "solid",
                    borderColor: "red",
                    borderWidth: "3px"
                  }}>{dispNextMonth}</span></Button>
                </>
              }
              {/* <Button className={classes.buttonTop} variant="contained" color="primary" onClick={()=>handleChange1()} disabled={disabledButton1}>
              {dispMonth}
              </Button>
              <Button className={classes.buttonTop} variant="contained" color="primary" onClick={()=>handleChange2()} disabled={disabledButton2}>
              {dispNextMonth}
              </Button> */}
            </Typography>
          </Grid>
        </Grid>
        <Card className={classes.root} square variant="outlined">
          <ApolloDataTable
            title=""
            data={displayData}
            columns={columns1}
            options={
              {
                ...options,
                textLabels: {
                  body: {noMatch: "該当データが存在しません"}
                },
              }
            }
          />
        </Card>
      </ApolloPageUsagePermission>
      <CustomizedSnackbars/>
    </GenericTemplate>
  );
};

const formatCsvData = (data: any[], tableData: AccountBudgetDisplay[], isThisMonth: boolean): CsvData[] => {
  const dataList: CsvData[] = [];
  data?.map((v: { index: any, data: any[] }) => {
      if (!v.data || v.data.length === 0) return;
      const values = tableData.filter((td) => td.accountId === v.data[0]);
      if (!values || values.length === 0) return;
      const d = values[0];
      const menuBudget = {
        optimize: 0,
        optimize1: 0,
        optimize2: 0,
        mail: 0,
        isSetMail: false,
        realtime: 0,
      }

      if (isThisMonth) {
        d.menuAmount?.map((menuAmount) => {
          switch (menuAmount.menuId) {
            case 1:
              if (menuAmount.budgetNo === 11) {
                menuBudget.optimize1 = menuAmount.amount1;
              } else if (menuAmount.budgetNo === 12) {
                menuBudget.optimize2 = menuAmount.amount1;
              } else {
                menuBudget.optimize = menuAmount.amount1;
              }
              break;

            case 2:
              if (!menuBudget.isSetMail) {
                menuBudget.mail = menuAmount.amount1;
                menuBudget.isSetMail = true;
              }else {
                menuBudget.realtime = menuAmount.amount1;
              }
              break;

            default:
              break;
          }
        });
      } else {
        d.menuAmount?.map((menuAmount) => {
          switch (menuAmount.menuId) {
            case 1:
              if (menuAmount.budgetNo === 11) {
                menuBudget.optimize1 = menuAmount.amount2;
              } else if (menuAmount.budgetNo === 12) {
                menuBudget.optimize2 = menuAmount.amount2;
              } else {
                menuBudget.optimize = menuAmount.amount2;
              }
              break;

            case 2:
              if (!menuBudget.isSetMail) {
                menuBudget.mail = menuAmount.amount2;
                menuBudget.isSetMail = true;
              }else {
                menuBudget.realtime = menuAmount.amount2;
              }
              break;

            default:
              break;
          }
        });
      }

      const list: CsvData = {
        index: v.index,
        data: [
          d.accountId,
          d.accountName,
          d.accountgroupId,
          d.accountgroupName,
          `￥${d.budgetAmount}`,
          `￥${menuBudget.mail}`,
          `￥${menuBudget.optimize}`,
          `￥${menuBudget.optimize1}`,
          `￥${menuBudget.optimize2}`,
        ],
      };
      dataList.push(list);
    }
  );
  return dataList;
}

export default BudgetPage;
